module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('va-dashboard-filter'), _vm._v(" "), (this.detailMode !== '') ? _c('div', [_c(_vm.bindDetail, {
    tag: "component",
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '1') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '2') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c(_vm.bindService, {
    tag: "component",
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : (this.layoutMode === '3') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('va-summary-td', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-summary-transport', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-main-eri', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1)]), _vm._v(" "), _c('va-summary-warehouse', {
    attrs: {
      "mode": this.filterMode,
      "fetchData": this.fetchData
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0eb987c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardServices.vue
// module id = 496
// module chunks = 1